module.exports = __webpack_public_path__ + "static/img/050.39ce7da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/yqs/050.png
// module id = VkuL
// module chunks = 0